import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../theme'

const PremiumWrapper = styled(Flex as any)<IPremiumWrapper>`
  color: white;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 ${({ size }) => (size ? 0.75 * size : 0.75)}em;
  font-size: ${({ size }) => (size ? 1.375 * size : 1.375)}em;
  & > span {
    font-size: ${({ size }) => (size ? 0.6 * size : 0.6)}em;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }

  ${is('show')`
    background-color: rgba(0,0,0,.15);
`}
`
export default PremiumWrapper

export interface IPremiumWrapper {
  show?: boolean
  size?: number
}
